import { Component } from '@angular/core';

@Component({
  selector: 'app-intranet-header',
  templateUrl: './intranet-header-demo-regular.component.html',
  styleUrls: ['../../intranet-layout.component.css'],
})
export class IntranetHeaderDemoRegularComponent {}
